
let defaultState = {

    state: "SPEECH_IDDLE", // Possible States SPEECH_IDDLE, SPEECH_ACTIVE
    text: ""
}

export default function (state=defaultState, action) {

    switch (action.type) {
        case "SPEECH_START":
            return Object.assign({}, state, {
                state: "SPEECH_START",
                text: ""
            })

        case "SPEECH_ABORT":
            return Object.assign({}, state, {
                state: "SPEECH_ABORT"
            })

        case "SPEECH_STOP":
            return Object.assign({}, state, {
                state: "SPEECH_STOP"
            })
        
        case "SPEECH_END":
            return Object.assign({}, state, {
                // text: "",
                state: "SPEECH_IDDLE",
            })

        case "SET_INTERIM_SPEECH":
            return Object.assign({}, state, {
                text: action.result
            })

        case "SET_FINAL_SPEECH":
            return Object.assign({}, state, {
                text: action.result,
                state: "SPEECH_IDDLE"
            })

        case "MIC_RESET":
            console.log("Microphone reset on MIC");
            return Object.assign({}, state, {
                text: "",
                state: "SPEECH_IDDLE"
            })

        default:
            return state
    }

}



// WEBPACK FOOTER //
// ./src/reducers/microphone.js